import React, { useState, useEffect, useRef } from 'react';
import SelectModules from './selectModules';
import MicsEditModule from './micsEditModule';
import ChatEditModule from './chatEditModule';
import TimerEditModule from './timerEditModule';
import ImageEditModule from './imageEditModule';
import TextEditModule from './textEditModule';
import WebcamEditModule from './webcamEditModule';
import AudioHubEditModule from './audioHubEditModule';
import AnalogClockEditModule from './analogClockEditModule';
import IFrameEditModule from './iFrameEditModule';
import ScheduleEditModule from './scheduleEditModule';
import ClockEditModule from './clockEditModule';
import _ from 'lodash';
import { Grid, Row, Button, Modal } from 'react-bootstrap';
import Request from 'superagent';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

export default function ConfigureEvent({ userProfile, eventID, refreshModulesInUse, configuredModules }) {
    const [moduleTypes, setModuleTypes] = useState([]);
    const [eventModules, setEventModules] = useState([]);
    const [editModuleRow, setEditModuleRow] = useState(null);
    const [items, setItems] = useState([]);
    const [prefixNbr, setPrefixNbr] = useState(0);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [cancelDisabled, setCancelDisabled] = useState(true);
    const [saveButtonsVisible, setSaveButtonsVisible] = useState(false);
    const [deselectNominatedItem, setDeselectNominatedItem] = useState(false);
    const [selectedModules, setSelectedModules] = useState([]);
    const [eventGroupingSeqInUse, setEventGroupingSeqInUse] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newEventGroupingSeq, setNewEventGroupingSeq] = useState(0);
    const [editAction, setEditAction] = useState('');
    const [moduleType, setModuleType] = useState('');
    const [selectedEventGroupingSeq, setSelectedEventGroupingSeq] = useState(null);
    const [eventModuleRow, setEventModuleRow] = useState(null);
    const [modulesDefinition, setModulesDefinition] = useState([]);
    const [customerFeatures, setCustomerFeatures] = useState([]);

    // CWRP eventID
    const firstEventIDRender = useRef(true);
    useEffect(() => {
        if (firstEventIDRender.current) { firstEventIDRender.current = false; return; }
        getModuleData();
        getEventModuleTypes(eventID);
    }, [eventID]);

    // CWRP refreshModulesInUse
    const firstRefreshRender = useRef(true);
    useEffect(() => {
        if (firstRefreshRender.current) { firstRefreshRender.current = false; return; }
        getModuleData();
        getModulesInUse(eventID);
    }, [refreshModulesInUse]);

    function getModuleData() {
        const params1 = JSON.stringify([{ customer_id: userProfile[0].customer_id }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetModulesDefinition&argument2=' + params1)
            .then(r => setModulesDefinition(r.body));
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetCustomerFeatures&argument2=' + params1)
            .then(r => setCustomerFeatures(r.body[0].data));

        const params2 = JSON.stringify([{ event_id: eventID, customer_id: userProfile[0].customer_id }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetModuleTypes&argument2=' + params2)
            .then(r => {
                if (r.body[0].Result === 'OK') {
                    setModuleTypes(r.body[0].data.map(d => {
                        d.nominatedCount = 0;
                        d.visible = !(d.multiple_allowed === 'f' && parseInt(d.instances, 10) > 0);
                        return d;
                    }));
                } else {
                    alert('In queryGetModuleTypes: ' + r.body[0].Result);
                }
            });
    }

    function saveEventModules(moduleRow) {
        const params = JSON.stringify([{
            module_type_id: moduleRow.module_type_id,
            name: moduleRow.name,
            colour: moduleRow.colour,
            flash: moduleRow.flash ? 't' : 'f',
            seconds: moduleRow.seconds,
            other_config: JSON.stringify(moduleRow.other_config),
            event_id: eventID,
            event_grouping_seq: moduleRow.event_grouping_seq,
        }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=updateEventModulest&argument2=' + params)
            .then(r => { if (r.body[0].Result !== 'OK') alert('In saveEventModules: ' + r.body[0].Result); });
    }

    function createEventModule(module_type_id) {
        const nextEventGroupingSeq = selectedModules.reduce((max, row) => Math.max(max, parseInt(row.event_grouping_seq, 10)), 0) + 1;
        setNewEventGroupingSeq(nextEventGroupingSeq);

        const params = JSON.stringify([{ event_id: eventID, module_type_id, event_grouping_seq: nextEventGroupingSeq }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=createEventModule&argument2=' + params)
            .then(r => {
                if (r.body[0].Result === 'OK') {
                    setEventModules(r.body[0].data);
                } else {
                    alert('In createEventModule: ' + r.body[0].Result);
                }
                getEventModuleTypes(eventID);
            });
    }

    function getEventModuleTypes(eid) {
        const newlyAddedGroupingSeq = newEventGroupingSeq;
        const params = JSON.stringify([{ eventID: eid }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=getEventModules&argument2=' + params)
            .then(r => {
                if (r.body[0].Result === 'OK') {
                    configuredModules(r.body[0].rowCount);
                    const newEventModules = r.body[0].data.map(d => ({
                        ...d,
                        module_type_description: d.name !== '' ? d.module_type + ' - ' + d.name : d.module_type,
                        other_config: d.other_config === null ? {} : JSON.parse(d.other_config),
                    }));
                    setEventModules(newEventModules);

                    const newSelectedModules = [];
                    let last_seq = 0;
                    newEventModules.forEach(d => {
                        if (d.event_grouping_seq !== last_seq) {
                            const newRow = { ...d, flash: d.flash === 't' };
                            newSelectedModules.push(newRow);
                            last_seq = d.event_grouping_seq;
                            if (newlyAddedGroupingSeq === parseInt(newRow.event_grouping_seq, 10)) {
                                editModuleFn(newRow, true, 'add');
                            }
                        }
                    });
                    setSelectedModules(newSelectedModules);
                } else {
                    alert('In getEventModuleTypes: ' + r.body[0].Result);
                }
            });
    }

    function getModulesInUse(eid) {
        const params = JSON.stringify([{ eventID: eid }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=getModulesInUse&argument2=' + params)
            .then(r => {
                if (r.body[0].Result === 'OK') {
                    setEventGroupingSeqInUse(r.body[0].data.map(d => ({ event_grouping_seq: d.event_grouping_seq, count: d.count })));
                } else {
                    alert('In getModulesInUse: ' + r.body[0].Result);
                }
            });
    }

    function moduleRemoved(seqOverride) {
        const seq = seqOverride ?? selectedEventGroupingSeq;
        const moduleTypeID = eventModuleRow?.module_type_id;

        editModuleFn({ module_type: '' }, false, 'remove');

        const params = JSON.stringify([{ event_id: eventID, event_grouping_seq: seq }]);
        Request.get(userProfile[0].serverIP + '/php/ob_clock.php?argument1=deleteEventModule&argument2=' + params)
            .then(r => {
                if (r.body[0].Result !== 'OK') alert('In moduleRemoved: ' + r.body[0].Result);
                getEventModuleTypes(eventID);
            });

        setModuleTypes(prev => prev.map(d => {
            if (d.module_type_id === moduleTypeID) {
                return { ...d, nominatedCount: 0, visible: d.multiple_allowed === 'f' ? true : d.visible };
            }
            return d;
        }));
        setShowModal(false);
    }

    function moduleAdded(ID) {
        createEventModule(ID);
        setModuleTypes(prev => prev.map(d => {
            if (d.module_type_id === ID) {
                return { ...d, nominatedCount: d.nominatedCount + 1, visible: d.multiple_allowed === 'f' ? false : d.visible };
            }
            return d;
        }));

        const itemsToBeAdded = modulesDefinition
            .filter(d => d.module_type_id === ID)
            .map(d => ({
                i: prefixNbr + ':' + d.id + ':',
                x: 0, y: 0,
                h: parseInt(d.min_height, 10),
                w: parseInt(d.min_width, 10),
                module_name: d.module_name,
                static: false,
            }));
        setItems(prev => [...prev.map(it => ({ ...it, static: true, i: prefixNbr + ':' + it.i.substring(it.i.indexOf(':') + 1) })), ...itemsToBeAdded]);
        setPrefixNbr(prev => prev + 1);
    }

    function eventModuleRowUpdated(row) {
        setEventModuleRow(row);
        setEventModules(prev => prev.map(d => d.event_grouping_seq === row.event_grouping_seq ? { ...d, colour: row.colour, name: row.name, other_config: row.other_config, flash: row.flash, seconds: row.seconds } : d));

        if (moduleType === 'Weather') {
            setSaveDisabled(!(row.citySelected && row.other_config.country.length > 2 && row.other_config.daysForecast.length > 0 && row.other_config.units.length > 0));
        } else if (moduleType === 'Webcam') {
            setSaveDisabled(row.other_config.callType === '' || row.name === '');
        } else if (moduleType === 'Clock') {
            setSaveDisabled(row.other_config.errorCount > 0);
        } else {
            setSaveDisabled(false);
        }
    }

    function handleSave() {
        const newEventModules = eventModules.map(d => {
            if (d.event_grouping_seq === eventModuleRow.event_grouping_seq) {
                const updated = { ...d, ...eventModuleRow };
                if (updated.name !== '') updated.module_type_description = updated.module_type + ' - ' + updated.name;
                return updated;
            }
            return d;
        });
        setEventModules(newEventModules);
        setSaveDisabled(true);
        saveEventModules(eventModuleRow);
        setSaveButtonsVisible(false);
        setEditModuleRow(null);
        setDeselectNominatedItem(true);

        const newSelectedModules = [];
        let last_seq = 0;
        newEventModules.forEach(d => {
            if (d.event_grouping_seq !== last_seq) {
                newSelectedModules.push({ ...d, flash: d.flash });
                last_seq = d.event_grouping_seq;
            }
        });
        setSelectedModules(newSelectedModules);
        setShowModal(false);
    }

    function handleCancel() {
        setSaveButtonsVisible(false);
        setShowModal(false);
        setEditModuleRow(null);
        setDeselectNominatedItem(true);

        if (newEventGroupingSeq > 0) {
            const seqToRemove = newEventGroupingSeq;
            setNewEventGroupingSeq(0);
            setSelectedEventGroupingSeq(seqToRemove);
            moduleRemoved(seqToRemove);
        }
    }

    function editModuleFn(row, isSelected, action) {
        if (isSelected) {
            setEditModuleRow(row);
            setModuleType(row.module_type);
            setSelectedEventGroupingSeq(row.event_grouping_seq);
            setShowModal(true);
            setSaveButtonsVisible(true);
            setSaveDisabled(row.module_type !== 'ClockX');
            setCancelDisabled(false);
            setDeselectNominatedItem(false);
        } else {
            setEditModuleRow(null);
            setSaveButtonsVisible(false);
            setDeselectNominatedItem(false);
        }
        setEventModuleRow(row);
        setEditAction(action);
    }

    function renderEditComponent(row) {
        const commonProps = { key: row.event_grouping_seq, eventModuleRow: row, updateEventModuleRow: eventModuleRowUpdated };
        switch (row.module_type) {
            case 'Message Box': return <TextEditModule {...commonProps} />;
            case 'Mics': return <MicsEditModule {...commonProps} />;
            case 'Timer': return <TimerEditModule {...commonProps} />;
            case 'Chat': return <ChatEditModule {...commonProps} />;
            case 'Image': return <ImageEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            case 'Webcam': return <WebcamEditModule {...commonProps} customerFeatures={customerFeatures} userProfile={userProfile} eventID={eventID} />;
            case 'AudioHub': return <AudioHubEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            case 'Analog Clock': return <AnalogClockEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            case 'iFrame': return <IFrameEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            case 'Schedule': return <ScheduleEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            case 'Clock': return <ClockEditModule {...commonProps} userProfile={userProfile} eventID={eventID} />;
            default: return null;
        }
    }

    const contentsVisible = { display: eventID === 0 ? 'none' : 'block' };
    const saveButtonsStyle = { display: saveButtonsVisible ? 'block' : 'none' };
    const useCount = eventGroupingSeqInUse.find(r => r.event_grouping_seq === selectedEventGroupingSeq)?.count ?? 0;
    const modalTitle = useCount > 0
        ? moduleType + ' assigned ' + (useCount === '1' ? 'once' : useCount + ' times')
        : moduleType;

    return (
        <div style={contentsVisible}>
            <Modal show={showModal}>
                <Modal.Header>
                    <Modal.Title>
                        {modalTitle}
                        {useCount === 0 && editAction !== 'add' && (
                            <Button bsStyle="primary"
                                style={{ right: '20px', top: '10px', position: 'absolute' }}
                                onClick={() => moduleRemoved()}>
                                Remove Module
                            </Button>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editModuleRow && renderEditComponent(editModuleRow)}
                </Modal.Body>
                <Modal.Footer>
                    <Button style={saveButtonsStyle} block name="save" disabled={saveDisabled} bsStyle="primary" onClick={handleSave}>Save</Button>
                    <Button style={saveButtonsStyle} block name="cancel" disabled={cancelDisabled} bsStyle="danger" onClick={handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
            <Grid>
                <Row>
                    <SelectModules
                        modulesDefinition={modulesDefinition}
                        nominatedModules={selectedModules}
                        eventGroupingSeqInUse={eventGroupingSeqInUse}
                        moduleTypes={moduleTypes}
                        deselectNominatedItem={deselectNominatedItem}
                        addModule={moduleAdded}
                        editModule={editModuleFn} />
                </Row>
            </Grid>
        </div>
    );
}
